module.exports = __webpack_public_path__ + "img/logo-icon.c73c6fae.png";